import { render, staticRenderFns } from "./sellersPriceModal.vue?vue&type=template&id=5163ef8a&scoped=true"
import script from "./sellersPriceModal.vue?vue&type=script&lang=js"
export * from "./sellersPriceModal.vue?vue&type=script&lang=js"
import style0 from "./sellersPriceModal.vue?vue&type=style&index=0&id=5163ef8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163ef8a",
  null
  
)

export default component.exports